export default __webpack_public_path__ + "static/media/interaction13.b059c12c.png";